// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cjS_i","delete":"styles_delete__-ZAqn","update":"styles_update__2WZ0F","add":"styles_add__2-pxC"};